import { render, staticRenderFns } from "./AppDownloads.vue?vue&type=template&id=094789b4&scoped=true"
import script from "./AppDownloads.vue?vue&type=script&lang=js"
export * from "./AppDownloads.vue?vue&type=script&lang=js"
import style0 from "./AppDownloads.vue?vue&type=style&index=0&id=094789b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094789b4",
  null
  
)

export default component.exports